import styled from '../../utils/styled';
import { mediaBreakpointDownMD } from '../../../constants/style-constants';

export const Container = styled.div({
  display: 'flex',
  position: 'relative',
  flexDirection: 'column',

  [mediaBreakpointDownMD]: {
    display: 'none',
  },
});

export const Trigger = styled.div({});

export const Content = styled.div(
  {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    right: '0',
    width: '200px',
    zIndex: '1',
  },
  ({ active }) => ({
    top: '100%',
    display: active ? 'flex' : 'none',

    [mediaBreakpointDownMD]: {
      display: 'none',
    },
  }),
);

export const NavbarButtonIcon = styled.img({
  display: 'block',
});
